"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorMapOverlay = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var core_shared_2 = require("@ikegps/core-shared");
var lodash_1 = require("lodash");
var lodash_2 = require("lodash");
var mobx_1 = require("mobx");
var mithril_component_1 = require("../../components/mithril.component");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var classnames_1 = require("../../util/classnames");
var projection_cache_1 = require("../google/projection.cache");
var map_line_1 = require("./map.line/map.line");
var map_point_1 = require("./map.point/map.point");
var point_collection_cache_1 = require("./point.collection.cache");
var CSS = {
    container: 'c-PhotomeasureOverlay',
    orca: 'c-PhotomeasureOverlay__device',
    orcaIcon: 'c-PhotomeasureOverlay__orcaIcon',
    fov: 'c-PhotomeasureOverlay__fov',
    fovSprite: 'c-PhotomeasureOverlay__fovSprite',
    label: 'c-PhotomeasureOverlay__label',
    line: 'c-MapOverlayLayer__line',
    point: 'c-MapOverlayLayer__point',
    hidden: 'c-MapOverlayLayer--hidden'
};
var Style = (_a = {},
    _a[CSS.container] = {
        position: 'absolute'
    },
    _a[CSS.orca] = {
        position: 'absolute',
        transform: 'translate3d(-16px, -16px, -1px)',
        width: '32px',
        height: '32px',
        borderRadius: '16px',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4
    },
    _a[CSS.orcaIcon] = {
        width: '32px',
        height: '32px',
        transformOrigin: '50% 50%'
    },
    _a[CSS.fov] = {
        position: 'absolute',
        left: 0,
        top: 0,
        transform: 'translate3d(-75px, -129px, -1px)'
    },
    _a[CSS.fovSprite] = {
        width: '150px',
        height: '129px',
        transformOrigin: '50% 100%'
    },
    _a[CSS.label] = {
        paddingTop: '20px'
    },
    _a[CSS.hidden] = {
        display: 'none'
    },
    _a);
(0, theme_1.addStyles)(Style);
var TopologicalEditorMapOverlay = /** @class */ (function (_super) {
    tslib_1.__extends(TopologicalEditorMapOverlay, _super);
    function TopologicalEditorMapOverlay(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.origin = new google.maps.LatLng(0, 0);
        _this.boundString = mobx_1.observable.box('', { name: 'BoundsString' });
        _this.collections = [];
        _this.selectedCollectionRevision = null;
        _this.selectedVectorId = null;
        _this.visible = true;
        _this.viewCollectionLabels = false;
        _this.hideTitles = false;
        _this.selectedVectorMoveDelta = {
            x: 0,
            y: 0
        };
        _this.name = 'TopologicalEditorMapOverlay';
        var collections = options.collections, selectedCollectionRevision = options.selectedCollectionRevision;
        _this.overlay = new google.maps.OverlayView();
        _this.overlay.setMap(options.map);
        _this.selectedCollectionRevision = selectedCollectionRevision || null;
        _this.collections = collections || null;
        _this.overlay.onAdd = function () {
            _this.el = _this.overlay.getPanes().overlayMouseTarget;
            services_1.Services.Render.mount(_this.el, _this, _this.name);
        };
        _this.overlay.onRemove = function () {
            if (_this.el) {
                services_1.Services.Render.mount(_this.el, null, _this.name);
            }
        };
        _this.overlay.draw = _this.onDraw.bind(_this);
        _this.boundVectorHandleMouseMove = _this.onVectorHandleDragMove.bind(_this);
        _this.boundVectorHandleMouseUp = _this.onVectorHandleMouseUp.bind(_this);
        return _this;
    }
    TopologicalEditorMapOverlay.prototype.onRemove = function () {
        if (this.el) {
            services_1.Services.Render.mount(this.el, null, this.name);
        }
    };
    TopologicalEditorMapOverlay.prototype.updateState = function () {
        this.setZoom(this.options.map.getZoom());
        this.setBounds(this.options.map.getBounds());
    };
    TopologicalEditorMapOverlay.prototype.setZoom = function (zoom) {
        this.zoom = zoom;
    };
    TopologicalEditorMapOverlay.prototype.setBounds = function (bounds) {
        var newBounds = bounds.toUrlValue();
        if (newBounds === this.boundString.get()) {
            return;
        }
        this.bounds = bounds;
        this.boundString.set(newBounds);
    };
    TopologicalEditorMapOverlay.prototype.onDraw = function () {
        var reset = this.verifyProjection();
        this.updateState();
        if (reset) {
            services_1.Services.Render.render(this.el, this.view());
        }
    };
    TopologicalEditorMapOverlay.prototype.setCollections = function (newCollections) {
        var summaries = newCollections.filter(Boolean);
        this.collections = summaries;
    };
    TopologicalEditorMapOverlay.prototype.setSelectedCollectionRevision = function (revision) {
        this.selectedCollectionRevision = revision;
    };
    TopologicalEditorMapOverlay.prototype.setSelectedVectorId = function (id) {
        this.selectedVectorId = id;
    };
    TopologicalEditorMapOverlay.prototype.hide = function () {
        this.visible = false;
        this.overlay.setMap(null);
    };
    TopologicalEditorMapOverlay.prototype.show = function () {
        this.visible = true;
        this.overlay.setMap(this.options.map);
    };
    TopologicalEditorMapOverlay.prototype.setInitialMove = function (coords) {
        this.selectedVectorInitialMove = coords;
    };
    TopologicalEditorMapOverlay.prototype.setInferredMoveDelta = function (coords) {
        this.selectedVectorMoveDelta = {
            x: coords.x - this.selectedVectorInitialMove.x,
            y: coords.y - this.selectedVectorInitialMove.y
        };
    };
    TopologicalEditorMapOverlay.prototype.setCapture = function (capture) {
        this.selectedCapture = capture;
        this.onDraw();
    };
    TopologicalEditorMapOverlay.prototype.resetMoveDelta = function () {
        this.selectedVectorMoveDelta = {
            x: 0,
            y: 0
        };
    };
    TopologicalEditorMapOverlay.prototype.onVectorHandleMouseDown = function (event) {
        if (this.options.onVectorDragStart) {
            this.options.onVectorDragStart();
        }
        this.setInitialMove((0, lodash_1.pick)(event, ['x', 'y']));
        window.addEventListener('mouseup', this.boundVectorHandleMouseUp);
        window.addEventListener('mousemove', this.boundVectorHandleMouseMove);
    };
    TopologicalEditorMapOverlay.prototype.onVectorHandleDragMove = function (event) {
        this.setInferredMoveDelta((0, lodash_1.pick)(event, ['x', 'y']));
    };
    TopologicalEditorMapOverlay.prototype.onVectorHandleMouseUp = function () {
        var _this = this;
        window.removeEventListener('mouseup', this.boundVectorHandleMouseUp);
        window.removeEventListener('mousemove', this.boundVectorHandleMouseMove);
        // See if any of the deltas have changed (ie not 0);
        if (Object.values(this.selectedVectorMoveDelta).some(Boolean)) {
            var vector = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(this.selectedCollectionRevision)
                .find(function (k) { return _this.selectedCollectionRevision + k.field.id === _this.selectedVectorId; });
            var _a = projection_cache_1.PointCache.getPoint(vector.target.latitude, vector.target.longitude), x = _a.x, y = _a.y;
            var terminal = new google.maps.Point(x + this.selectedVectorMoveDelta.x, y + this.selectedVectorMoveDelta.y);
            var _b = this.overlay.getProjection().fromDivPixelToLatLng(terminal), lat = _b.lat, lng = _b.lng;
            var nextVector = core_shared_2.IkeGeodesic.getVector(vector.field.collection.location, {
                latitude: lat(),
                longitude: lng(),
                altitude: 0
            });
            vector.field.Mutator.manual(nextVector);
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(this.selectedCollectionRevision);
            this.resetMoveDelta();
        }
    };
    TopologicalEditorMapOverlay.prototype.setCollectionHoveredId = function (id) {
        this.collectionHoverId = id;
    };
    TopologicalEditorMapOverlay.prototype.setVectorHoverId = function (id) {
        this.collectionAndVectorHoverId = id;
    };
    TopologicalEditorMapOverlay.prototype.setHideTitles = function (hide) {
        this.hideTitles = hide;
    };
    TopologicalEditorMapOverlay.prototype.verifyProjection = function () {
        var projection = this.overlay.getProjection();
        if (projection == null) {
            projection_cache_1.PointCache.reset();
            return true;
        }
        projection_cache_1.PointCache.setProjection(projection);
        var point = projection.fromLatLngToDivPixel(this.origin);
        var oldPoint = projection_cache_1.PointCache.getPoint(this.origin.lat(), this.origin.lng());
        if (point.x !== oldPoint.x || point.y !== oldPoint.y) {
            projection_cache_1.PointCache.reset();
            return true;
        }
        return false;
    };
    TopologicalEditorMapOverlay.prototype.canSeeFieldOfView = function () {
        return (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_FIELD_OF_VIEW));
    };
    Object.defineProperty(TopologicalEditorMapOverlay.prototype, "nodes", {
        get: function () {
            var _this = this;
            this.verifyProjection();
            var output = this.collections.reduce(function (acc, collection) {
                var _a, _b;
                var location;
                location = collection.location;
                var summary = store_1.AppStore.CollectionSummary.get(collection.revision);
                var point = projection_cache_1.PointCache.getGeoPoint({
                    type: 'point',
                    coordinates: [(0, lodash_2.get)(location, ['longitude'], 0), (0, lodash_2.get)(location, ['latitude'], 0)]
                });
                var vectors = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(summary.revision);
                var lines = vectors
                    // Check to make sure that the vectors that are there actually exist before drawing them
                    .filter(function (vector) { return vector.field.value; })
                    .map(function (vector) { return new map_line_1.MapLine({
                    vector: vector,
                    initialPoint: point,
                    isSelected: _this.selectedVectorId === summary.revision + vector.field.id && vector.field.collection.revision === _this.selectedCollectionRevision,
                    drawLabels: _this.showLabelsOnMap(),
                    showVectorLabel: [_this.collectionAndVectorHoverId, _this.selectedVectorId].includes(summary.revision + vector.field.id),
                    onClick: function () {
                        _this.options.onVectorClick(summary.revision, vector.field.id);
                        _this.setSelectedVectorId(summary.revision + vector.field.id);
                    },
                    onVectorMouseOver: function () {
                        _this.setVectorHoverId(summary.revision + vector.field.id);
                    },
                    onVectorMouseOut: function () {
                        _this.setVectorHoverId(null);
                    },
                    onVectorHandleMouseDown: vector.field.isCollectionLink() ? lodash_1.noop : function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        _this.onVectorHandleMouseDown(event);
                    },
                    vectorHandleMoveDelta: _this.selectedVectorMoveDelta
                }); });
                var poleAccuracy = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionPoleAccuracy(summary.revision);
                var pointView = map_point_1.MapPoint.view({
                    summary: summary,
                    point: point,
                    isCollectionSelected: summary.revision === _this.selectedCollectionRevision,
                    poleAccuracy: poleAccuracy,
                    onClick: function () {
                        if (page_state_1.CurrentState.CollectionLink.isLinking) {
                            page_state_1.CurrentState.CollectionLink.completeLinking(summary);
                            return;
                        }
                        _this.options.onCollectionClick(summary.revision);
                        _this.setSelectedVectorId(null);
                    },
                    onCollectionMouseOver: function () {
                        _this.setCollectionHoveredId(summary.objectId);
                    },
                    onCollectionMouseOut: function () {
                        _this.setCollectionHoveredId(null);
                    },
                    showCollectionTitle: _this.collectionHoverId === summary.objectId,
                    showTitlesOnMap: _this.showLabelsOnMap()
                });
                var pointLayer = pointView
                    ? (0, mithril_1.m)('div', {
                        key: "layer-point-".concat(summary.revision),
                        className: (0, classnames_1.classNames)(CSS.point, (_a = {},
                            _a[CSS.hidden] = !_this.visible,
                            _a))
                    }, pointView)
                    : null;
                var lineLayer = lines.length
                    ? (0, mithril_1.m)('div', {
                        key: "layer-line-".concat(summary.revision),
                        className: (0, classnames_1.classNames)(CSS.line, (_b = {},
                            _b[CSS.hidden] = !_this.visible,
                            _b))
                    }, lines.map(function (x) { return x.nodes; }))
                    : null;
                return tslib_1.__spreadArray(tslib_1.__spreadArray([
                    lineLayer
                ], acc, true), [
                    pointLayer
                ], false);
            }, []);
            var projection = this.overlay.getProjection();
            if (this.selectedCapture && this.selectedCapture.device && this.canSeeFieldOfView() && projection) {
                var _a = this.selectedCapture.device, latitude = _a.latitude, longitude = _a.longitude;
                var point = projection.fromLatLngToDivPixel(new google.maps.LatLng({
                    lat: latitude,
                    lng: longitude
                }));
                var photomeasureNodes = (0, mithril_1.m)('div', {
                    className: CSS.container,
                    style: {
                        left: "".concat(point.x, "px"),
                        top: "".concat(point.y, "px"),
                        zIndex: -1
                    }
                }, [
                    (0, mithril_1.m)('div', {
                        className: CSS.fov
                    }, (0, mithril_1.m)('img', {
                        src: (0, theme_1.assetPath)('/images/fov-cone.svg'),
                        className: CSS.fovSprite,
                        style: {
                            transform: "rotate(".concat(this.selectedCapture.orientation.bearing, "rad)")
                        }
                    })),
                    (0, mithril_1.m)('div', {
                        className: CSS.orca
                    }, (0, mithril_1.m)('img', {
                        src: (0, theme_1.assetPath)('/images/ike-device.svg'),
                        className: CSS.orcaIcon,
                        style: {
                            transform: "rotate(".concat(this.selectedCapture.orientation.bearing, "rad)")
                        }
                    })),
                    (0, mithril_1.m)('div', {
                        className: CSS.label
                    }, core_shared_1.IkeUnit.display(this.selectedCapture.distance, services_1.Services.UserSettings.units))
                ]);
                output.push(photomeasureNodes);
            }
            return output.filter(Boolean);
        },
        enumerable: false,
        configurable: true
    });
    TopologicalEditorMapOverlay.prototype.view = function () {
        return mithril_1.m.fragment({}, this.nodes);
    };
    TopologicalEditorMapOverlay.prototype.toggleViewTitles = function () {
        this.viewCollectionLabels = !this.viewCollectionLabels;
    };
    TopologicalEditorMapOverlay.prototype.showLabelsOnMap = function () {
        if (this.hideTitles) {
            return false;
        }
        return this.viewCollectionLabels;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "bounds", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "zoom", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "collections", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "selectedCollectionRevision", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "selectedVectorId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "visible", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "collectionHoverId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "collectionAndVectorHoverId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "viewCollectionLabels", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "hideTitles", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "selectedVectorMoveDelta", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "selectedVectorInitialMove", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorMapOverlay.prototype, "selectedCapture", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorMapOverlay.prototype, "updateState", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setZoom", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setBounds", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setCollections", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setSelectedCollectionRevision", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setSelectedVectorId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "hide", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "show", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setInitialMove", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setInferredMoveDelta", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setCapture", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "resetMoveDelta", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "onVectorHandleMouseDown", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "onVectorHandleDragMove", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "onVectorHandleMouseUp", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setCollectionHoveredId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setVectorHoverId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorMapOverlay.prototype, "setHideTitles", null);
    return TopologicalEditorMapOverlay;
}(mithril_component_1.IMithrilComponent));
exports.TopologicalEditorMapOverlay = TopologicalEditorMapOverlay;
//# sourceMappingURL=topological.editor.map.overlay.js.map